import React from 'react';

const ContactListItem = ({ contact, last, onSelectContact }) => (
  <div style={{ display: 'flex', alignItems: 'center', padding: '18px 24px', borderBottom: last ? 'none' : '1px solid #f0f0f0' }}>
    {/* Avatar */}
    <div style={{ width: 48, height: 48, borderRadius: '50%', background: '#e3e7ed', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 20, color: '#3b4a6b', marginRight: 18, overflow: 'hidden' }}>
      {contact.avatarUrl ? (
        <img src={contact.avatarUrl} alt={contact.name} style={{ width: 48, height: 48, borderRadius: '50%' }} />
      ) : (
        contact.name.split(' ').map(w => w[0]).join('').slice(0,2)
      )}
    </div>
    {/* Info */}
    <div style={{ flex: 1 }}>
      <div style={{ fontWeight: 700, fontSize: 17 }}>{contact.name}</div>
      <div style={{ color: '#6b7280', fontSize: 15 }}>{contact.role}</div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 2 }}>
        <span style={{ width: 10, height: 10, borderRadius: '50%', background: contact.statusColor, display: 'inline-block' }}></span>
        <span style={{ color: contact.statusColor, fontSize: 14 }}>{contact.status}</span>
      </div>
    </div>
    {/* Message Button */}
    <button
      style={{
        background: contact.isOnline ? '#1976d2' : '#e3e7ed',
        color: contact.isOnline ? '#fff' : '#888',
        border: 'none',
        borderRadius: 8,
        padding: '10px 22px',
        fontWeight: 600,
        fontSize: 16,
        cursor: contact.isOnline ? 'pointer' : 'not-allowed',
        transition: 'background 0.15s',
        marginLeft: 18
      }}
      disabled={!contact.isOnline}
      onClick={() => onSelectContact && onSelectContact(contact)}
    >
      <span role="img" aria-label="message">💬</span> Message
    </button>
  </div>
);

export default ContactListItem; 